import { useState } from "react";
import { usePageMeta } from "../hooks/usePageMeta";
import { FadeIn } from "../components/site/FadeIn";
import { SectionHeading } from "../components/site/SectionHeading";
import { ProjectCard } from "../components/site/ProjectCard";
import { ProjectPopup } from "../components/site/ProjectPopup";
import { POPUP_PROJECTS, CARD_ORDER, TABLE_PROJECTS } from "../data/projects";

export default function Projects() {
  usePageMeta(
    "Projects — Keyur Sorathia",
    "Thirteen funded projects in immersive learning, health systems, accessibility and civic technology."
  );
  const [popup, setPopup] = useState(null);
  const cards = CARD_ORDER.map((k) => POPUP_PROJECTS.find((p) => p.key === k));

  return (
    <div data-testid="projects-page">
      <section className="section">
        <div className="container-site">
          <FadeIn>
            <h1 className="text-h1 mb-6" style={{ color: "var(--navy-700)" }}>Sponsored projects</h1>
            <p className="body-lg measure mb-12">
              Every project here was built and then installed somewhere real.
            </p>
          </FadeIn>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {cards.map((p) => (
              <FadeIn key={p.key}>
                <ProjectCard project={p} onOpen={setPopup} detailed />
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      <section className="section" style={{ background: "var(--surface-alt)" }}>
        <div className="container-site">
          <FadeIn>
            <SectionHeading eyebrow="The full record" title="Every funded project, by value" />
          </FadeIn>

          <div className="hidden md:block">
            <table className="spec-table" data-testid="projects-table">
              <thead>
                <tr>
                  <th scope="col">Project</th>
                  <th scope="col">Funder</th>
                  <th scope="col">Value</th>
                  <th scope="col">Role and years</th>
                </tr>
              </thead>
              <tbody>
                {TABLE_PROJECTS.map((r) => (
                  <tr key={r.project}>
                    <td style={{ color: "var(--ink-900)", fontWeight: 500 }}>{r.project}</td>
                    <td>{r.funder}</td>
                    <td>{r.value}</td>
                    <td>{r.role}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="md:hidden flex flex-col gap-4" data-testid="projects-table-mobile">
            {TABLE_PROJECTS.map((r) => (
              <div key={r.project} className="bg-white p-4" style={{ border: "1px solid var(--border-default)", borderRadius: 8 }}>
                <p className="body-sm font-medium m-0 mb-2" style={{ color: "var(--ink-900)" }}>{r.project}</p>
                <p className="caption m-0"><span className="font-semibold">Funder:</span> {r.funder}</p>
                <p className="caption m-0"><span className="font-semibold">Value:</span> {r.value}</p>
                <p className="caption m-0"><span className="font-semibold">Role and years:</span> {r.role}</p>
              </div>
            ))}
          </div>

        </div>
      </section>

      <ProjectPopup project={popup} onClose={() => setPopup(null)} />
    </div>
  );
}
